/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ImplementDataDto } from './implementDataDto';
import { ImplementIdDto } from './implementIdDto';
import { MachineDataDto } from './machineDataDto';

export interface ImplementStatsV2Dto {
  implement?: ImplementIdDto;
  implementData?: ImplementDataDto;
  implementDataField?: ImplementDataDto;
  implementDataLocation?: ImplementDataDto;
  implementDataRoad?: ImplementDataDto;
  machineData?: Array<MachineDataDto>;
  machineDataField?: Array<MachineDataDto>;
  machineDataLocation?: Array<MachineDataDto>;
  machineDataRoad?: Array<MachineDataDto>;
}
